import React from "react";
import PriceAdvisorMessage from "duck/ui/chat/components/messages/PriceAdvisorMessage/PriceAdvisorMessage";
import {
  MessageType,
  PriceAdviceData,
  type AssistantMessageContent,
} from "duck/ui/chat/types";

import { Renderer, RendererContext } from "./types";

const hasWorkOrderPricingVerification = (
  content: AssistantMessageContent
): boolean =>
  content.message_type === MessageType.WORKORDER_PRICING_VERIFICATION &&
  "workorder_pricing_verification" in content;

export const WorkOrderPricingVerificationRenderer: Renderer<AssistantMessageContent> =
  {
    type: "workorder_pricing_verification",
    canRender: (content: AssistantMessageContent): boolean =>
      hasWorkOrderPricingVerification(content),

    render: (
      content: AssistantMessageContent,
      context?: RendererContext
    ): React.ReactNode => {
      if (!hasWorkOrderPricingVerification(content)) return null;

      const { workorder_pricing_verification } = content as PriceAdviceData;

      return (
        <PriceAdvisorMessage
          parsedObject={workorder_pricing_verification}
          appendMessageWithPydanticAi={true}
          isStreaming={context?.isStreaming || false}
        />
      );
    },
  };
